var React = require('react');

function Wallet (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"nonzero","stroke":"currentColor","strokeLinejoin":"round","strokeWidth":"2","d":"M8.452 25.255h-1.22a1.706 1.706 0 0 1 0-3.383H27a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H6a3 3 0 0 0-3 3v19.301a3 3 0 0 0 3 3h19.323a2 2 0 0 0 2-2v-.944"}));
}

Wallet.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Wallet;

Wallet.default = Wallet;
